import { DELIVERY_PROJECT_MNG, DELIVERY_PLAN_MNG } from '@/api/apiModules'
import lang from '@/lang'

import dictionary from '@/utils/dictionary'

const viewMetaData = {
  viewType: 'table',
  module: DELIVERY_PROJECT_MNG,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  params: {
    isTemplate: false,
    flowStatus: [
      'MDR_DEPLOY_PROJECT_INIT',
      'MDR_DEPLOY_JOB_PC_INFO',
      'MDR_DEPLOY_REQUIREMENT_CHECK',
      'MDR_DEPLOY_NETWORK_INFO',
      'MDR_DEPLOY_SOLUTION_BUILD'
    ]
  },
  refreshInterval: 20000,
  // relationSearch: true,
  // // allowStatus: {},
  allowStatus: {
    //设置按钮权限
    SetDdProjectTemplate: {
      expression: function(row) {
        return this.$store.getters.baseInfo.hasSuperPrivilege === true && row.flowStatus === 'MDR_DEPLOY_SOLUTION_BUILD'
      }
    }
  },
  toolbar: {
    searchWidth: 360,
    moreBtnWidth: 160,
    // hasColAdjustment: true,
    searchPlaceholder: 'pocMng.searchPlaceholder',
    searchFieldNameArr: ['customer', 'projectCode', 'projectName'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'deliveryMng.createDdProjectFromTem',
        props: {
          disabled: false,
          type: 'primary',
          icon: 'el-icon-plus'
        },
        tip: 'deliveryMng.createNewDdProject',
        action: 'CreateDdProjectFromTem'
      },
      {
        slot: 'refresh-rigtht',
        label: 'deliveryMng.createNewDdProject',
        props: {
          disabled: false,
          type: 'primary',
          icon: 'el-icon-plus'
        },
        tip: 'deliveryMng.createNewDdProject',
        action: 'CreateDeliveryDetailProject'
      }
    ],
    tips: {
      label: '注：现只支持中小企业普通办公场景交付',
      type: 'info'
    }
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: 'pocMng.projectNumber',
          prop: 'projectCode',
          width: 105
        }
      },
      {
        props: {
          label: 'pocMng.projectName',
          prop: 'projectName',
          sortField: 'projectName'
        }
      },
      {
        props: {
          label: 'pocMng.customer',
          prop: 'customer',
          sortField: 'customer',
          width: 255
        }
      },
      {
        props: {
          label: 'pocMng.industry',
          prop: 'industryId',
          width: 110
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.industryName
        },
        filter: true,
        url: `industry/list`,
        params: {
          limit: 100,
          page: 0
        }
      },
      {
        props: {
          label: '管理者',
          prop: 'salesLeaderIds',
          sortField: 'salesLeaderIds',
          width: 100
        },
        filters: [],
        filter: true,
        dataType: 'custom',
        custom: function(row, h, value, e) {
          if (!row.salesLeaderLabelList) {
            return ''
          }
          const nameArr = row.salesLeaderLabelList.map(item => item.label).join(', ')
          return <span>{nameArr}</span>
        },
        url: `/delivery/project/salesLeader/list`,
        params: {
          hasTemplate: false,
          flowStatusList: [
            'MDR_DEPLOY_PROJECT_INIT',
            'MDR_DEPLOY_JOB_PC_INFO',
            'MDR_DEPLOY_REQUIREMENT_CHECK',
            'MDR_DEPLOY_NETWORK_INFO',
            'MDR_DEPLOY_SOLUTION_BUILD'
          ]
        }
      },
      // {
      //   props: {
      //     label: 'pocMng.sales',
      //     prop: 'salesName',
      //     sortField: 'salesName',
      //     width: 100
      //   }
      // },
      {
        props: {
          label: 'pocMng.presales',
          prop: 'presalesId',
          sortField: 'presalesId',
          width: 100
        },
        filters: [],
        filter: true,
        dataType: 'custom',
        custom: function(row, h, value, e) {
          if (!row.presalesIdLabel) {
            return ''
          }
          return <span>{row.presalesIdLabel.label}</span>
        },
        url: `/delivery/project/preSales/list`,
        params: {
          hasTemplate: false,
          flowStatusList: [
            'MDR_DEPLOY_PROJECT_INIT',
            'MDR_DEPLOY_JOB_PC_INFO',
            'MDR_DEPLOY_REQUIREMENT_CHECK',
            'MDR_DEPLOY_NETWORK_INFO',
            'MDR_DEPLOY_SOLUTION_BUILD'
          ]
        }
      },
      {
        props: {
          label: 'pocMng.postsales',
          prop: 'postsalesIds',
          sortField: 'postsalesIds',
          width: 100
        },
        filter: true,
        dataType: 'custom',
        custom: function(row, h, value, e) {
          if (!row.postsalesIdLabelList) {
            return ''
          }
          const nameArr = row.postsalesIdLabelList.map(item => item.label).join(', ')
          return <span>{nameArr}</span>
        },
        url: `/delivery/project/postSales/list`,
        params: {
          hasTemplate: false,
          flowStatusList: [
            'MDR_DEPLOY_PROJECT_INIT',
            'MDR_DEPLOY_JOB_PC_INFO',
            'MDR_DEPLOY_REQUIREMENT_CHECK',
            'MDR_DEPLOY_NETWORK_INFO',
            'MDR_DEPLOY_SOLUTION_BUILD'
          ]
        }
      },
      {
        props: {
          label: 'pocMng.pocState',
          prop: 'flowStatus',
          sortField: 'flowStatus',
          width: 145
        },
        filter: true,
        dictionaryPath: 'deliveryFlowStatus',
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }
          if (dictionary['deliveryFlowStatus'][data.flowStatus].type) {
            const renderItem = [
              <el-tag type={dictionary['deliveryFlowStatus'][data.flowStatus].type}>
                {lang.t(dictionary['deliveryFlowStatus'][data.flowStatus].label)}
              </el-tag>
            ]
            return renderItem
          } else {
            const renderItem = [
              <el-tag color={dictionary['deliveryFlowStatus'][data.flowStatus].color}>
                {lang.t(dictionary['deliveryFlowStatus'][data.flowStatus].label)}
              </el-tag>
            ]
            return renderItem
          }
        }
      },
      {
        props: {
          label: 'pocMng.projectSourceType',
          prop: 'projectSourceType',
          sortField: 'projectSourceType',
          width: 100
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'projectSourceType'
      },
      {
        props: {
          label: 'pocMng.createTime',
          prop: 'createTime',
          sortable: 'custom',
          sortField: 'createTime',
          width: 125
        },
        //dataType: 'date'
        dataType: 'custom',
        custom: function(row, h, value, e) {
          var date = new Date(value)
          var Y = date.getFullYear() + '-'
          var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
          var D = date.getDate() + 1 > 10 ? date.getDate() : '0' + date.getDate()
          return <span>{Y + M + D}</span>
        }
      },
      {
        props: {
          label: 'pocMng.createUserName',
          prop: 'createUserName',
          sortField: 'createUserName',
          width: 105
        }
      },
      {
        props: {
          label: 'pocMng.projectPlan',
          prop: 'planFlag',
          width: 105
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }

          let vNode = [
            <div class="wsp-display-flex-center">
              <div class="wsp-width-20 el-icon-download"></div>
              <div class="wsp-width-80">
                <div
                  class="sk-link--normal  wsp-width-100"
                  on-click={$event => {
                    this.$store.dispatch('customDownloadDocument', {
                      module: DELIVERY_PLAN_MNG,
                      params: {
                        id: data.id
                      },
                      action: 'downloadPlan'
                    })
                  }}
                >
                  <span>Word</span>
                </div>
              </div>
            </div>
          ]

          if (data.planFlag === 'Y') {
            return vNode
          }
          if (data.planFlag === 'N') {
            return <span>未生成</span>
          }
          return
        }
      },
      {
        //操作
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'pocMng.btns.deal',
        command: 'ShowdeliveryDeployProjectDetail',
        name: 'ShowdeliveryDeployProjectDetail'
      },
      // {
      //   icon: 'el-icon-edit',
      //   label: 'pocMng.btns.edit',
      //   command: 'EditProTestProjectBaseInfo',
      //   name: 'EditProTestProjectBaseInfo'
      // },
      // {
      //   icon: 'el-icon-delete',
      //   label: 'delete',
      //   command: 'UmDeleteProject',
      //   name: 'UmDeleteProject',
      //   confirm: {
      //     grade: 0,
      //     msg: 'pocMng.tips.deletePocProject'
      //   }
      // },
      {
        icon: 'el-icon-edit',
        label: 'pocMng.btns.setTemplate',
        command: 'SetDdProjectTemplate',
        name: 'SetDdProjectTemplate',
        tip: '项目必须为方案生成状态且为管理员才允许操作'
      }
    ]
  }
}

export default viewMetaData
